//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { ContentCollection, Language } from '@constants'
import polling from '~/mixins/poll-when-visible'

const CONTENT_COLLECTIONS = gql`
  fragment ArticleFields on Article {
    id
    externalId
    date
    title
    slug
    abstract
    imageUrl
    redirectUrl
    edition {
      id
      name
    }
    country {
      id
      name
    }
    region {
      id
      name
    }
    contentType {
      id
      name
      colour
      contentTypeGroup {
        id
        name
      }
    }
    contentSource {
      id
      name
    }
  }

  query ($language: Int) {
    WIRELESS: contentCollectionArticles(
      first: 4
      where: { contentCollectionId: { eq: ${ContentCollection.WIRELESS} }, article: { languageId: { eq: $language } } }
      order: [{ article: { date: DESC } }]
    ) {
      nodes {
        article {
          ...ArticleFields
        }
      }
    }
    BROADBAND: contentCollectionArticles(
      first: 4
      where: { contentCollectionId: { eq: ${ContentCollection.BROADBAND} }, article: { languageId: { eq: $language } } }
      order: [{ article: { date: DESC } }]
    ) {
      nodes {
        article {
          ...ArticleFields
        }
      }
    }
    VIDEO: contentCollectionArticles(
      first: 4
      where: { contentCollectionId: { eq: ${ContentCollection.VIDEO} }, article: { languageId: { eq: $language } } }
      order: [{ article: { date: DESC } }]
    ) {
      nodes {
        article {
          ...ArticleFields
        }
      }
    }
    GENERAL: contentCollectionArticles(
      first: 4
      where: { contentCollectionId: { eq: ${ContentCollection.GENERAL} }, article: { languageId: { eq: $language } } }
      order: [{ article: { date: DESC } }]
    ) {
      nodes {
        article {
          ...ArticleFields
        }
      }
    }
    IT: contentCollectionArticles(
      first: 4
      where: { contentCollectionId: { eq: ${ContentCollection.IT} }, article: { languageId: { eq: $language } } }
      order: [{ article: { date: DESC } }]
    ) {
      nodes {
        article {
          ...ArticleFields
        }
      }
    }
    PARTNER_CONTENT: contentCollectionArticles(
      first: 4
      where: {
        contentCollectionId: { eq: ${ContentCollection.PARTNER_CONTENT} }
        article: { languageId: { eq: $language } }
      }
      order: [{ article: { date: DESC } }]
    ) {
      nodes {
        article {
          ...ArticleFields
        }
      }
    }
    FTTH: contentCollectionArticles(
      first: 4
      where: { contentCollectionId: { eq: ${ContentCollection.FTTH} }, article: { languageId: { eq: $language } } }
      order: [{ article: { date: DESC } }]
    ) {
      nodes {
        article {
          ...ArticleFields
        }
      }
    }
    AI: contentCollectionArticles(
      first: 4
      where: { contentCollectionId: { eq: ${ContentCollection.AI} }, article: { languageId: { eq: $language } } }
      order: [{ article: { date: DESC } }]
    ) {
      nodes {
        article {
          ...ArticleFields
        }
      }
    }
    DATA_CENTRE: contentCollectionArticles(
      first: 4
      where: {
        contentCollectionId: { eq: ${ContentCollection.DATA_CENTRE} }
        article: { languageId: { eq: $language } }
      }
      order: [{ article: { date: DESC } }]
    ) {
      nodes {
        article {
          ...ArticleFields
        }
      }
    }
    RESEARCH: contentCollectionArticles(
      first: 4
      where: {
        contentCollectionId: { eq: ${ContentCollection.RESEARCH} }
        article: { languageId: { eq: ${Language.ENGLISH} } }
      }
      order: [{ article: { date: DESC } }]
    ) {
      nodes {
        article {
          ...ArticleFields
        }
      }
    }
  }
`

export default {
  name: 'ContentCollections',
  mixins: [polling],
  data() {
    return {
      ContentCollection,
      contentCollections: []
    }
  },
  fetchOnServer: true,
  async fetch() {
    if (!this.canShow) return
    this.$store.set('dataFetchingCount/dataFetchingCount', this.$store.get('dataFetchingCount/dataFetchingCount') + 1)
    await this.refresh()
    this.$store.set('dataFetchingCount/dataFetchedCount', this.$store.get('dataFetchingCount/dataFetchedCount') + 1)
  },
  computed: {
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    },
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    },
    filteredContent() {
      return this.contentCollections.filter((x) => x.articles.length > 2)
    },
    canShow() {
      if (process.server) return true
      return typeof navigator !== 'undefined' && !navigator.userAgent.includes('Chrome-Lighthouse')
    }
  },
  watch: {
    async languageId() {
      await this.refresh(true)
    }
  },
  mounted() {
    if (this.$nuxt.context.isClient && this.canShow) {
      this.startPolling(() => this.refresh(true), 5 * 60 * 1000)
    }
  },
  methods: {
    async refresh(purge = false) {
      const { data } = await this.$apollo.query({
        query: CONTENT_COLLECTIONS,
        variables: {
          language: this.languageId
        },
        fetchPolicy: purge ? 'network-only' : 'cache-first'
      })

      const contentCollections = []

      Object.keys(ContentCollection).forEach((key) => {
        const id = ContentCollection[key]

        contentCollections.push({
          id,
          name: this.getName(id),
          articles: this.prependImagePreview(data[key]?.nodes, id),
          noSpacer: this.currentBreakPoint === this.xsBreakPoint() ? true : id !== ContentCollection.PARTNER_CONTENT,
          hasCardBorder: this.currentBreakPoint === this.xsBreakPoint() && id !== ContentCollection.PARTNER_CONTENT,
          background: id === ContentCollection.PARTNER_CONTENT ? 'grey' : '',
          order: this.getOrder(id)
        })
      })

      contentCollections.sort((a, b) => a.order - b.order)

      this.contentCollections = contentCollections
    },
    getName(id) {
      switch (id) {
        case ContentCollection.MWC_2026:
          return this.$t('content_collection.mwc')
        case ContentCollection.DATA_CENTRE:
          return this.$t('content_collection.data_centre')
        case ContentCollection.AI:
          return this.$t('content_collection.ai')
        case ContentCollection.FTTH:
          return this.$t('content_collection.ftth')
        case ContentCollection.WIRELESS:
          return this.$t('content_collection.wireless')
        case ContentCollection.BROADBAND:
          return this.$t('content_collection.broadband')
        case ContentCollection.VIDEO:
          return this.$t('content_collection.video')
        case ContentCollection.GENERAL:
          return this.$t('content_collection.general')
        case ContentCollection.IT:
          return this.$t('content_collection.it')
        case ContentCollection.PARTNER_CONTENT:
          return this.$t('content_collection.partner_content')
        case ContentCollection.RESEARCH:
          return this.$t('content_collection.research')
      }
    },
    getOrder(id) {
      switch (id) {
        case ContentCollection.MWC_2026:
          return 0
        case ContentCollection.DATA_CENTRE:
          return 1
        case ContentCollection.AI:
          return 2
        case ContentCollection.FTTH:
          return 3
        case ContentCollection.WIRELESS:
          return 4
        case ContentCollection.BROADBAND:
          return 5
        case ContentCollection.VIDEO:
          return 6
        case ContentCollection.PARTNER_CONTENT:
          return 7
        case ContentCollection.RESEARCH:
          return 8
        case ContentCollection.GENERAL:
          return 9
        case ContentCollection.IT:
          return 10
      }
    },
    prependImagePreview(articles = [], contentCollectionId) {
      if (!articles.length) return articles

      const random = Math.floor(Math.random() * 10) + 1
      const showFullImage = random >= 6
      if (!showFullImage) return articles

      const prependItem = (arr, val) => {
        const newArray = arr.slice()
        newArray.unshift(val)
        return newArray
      }

      let result = [...articles]
      const [firstArticle] = result

      if (
        firstArticle.article.imageUrl &&
        contentCollectionId !== ContentCollection.PARTNER_CONTENT &&
        this.currentBreakPoint !== this.xsBreakPoint()
      ) {
        result = prependItem(articles, {
          ...firstArticle,
          isFullImage: showFullImage,
          showImage: contentCollectionId !== ContentCollection.PARTNER_CONTENT
        })
      }

      return result
    }
  }
}
